import { ContentService } from "../../../services/content.service.js";
import { SearchResultsGrid } from "./SearchResultsGrid.js";
import { locale } from "../../../services/LocaleService.js";

// "Grand" Gallery because it handles "All Works"
export const GrandGallerySection = () => {
    const container = document.createElement('div');
    // [FIX] Removed mt-8 pt-8 border-t to match gap-12 rhythm
    // container.className = "mt-8 pt-8 border-t border-zinc-100";  
    container.className = "";

    // Header & Controls
    container.innerHTML = `
        <div class="flex items-center justify-between mb-4 px-1 md:px-0">
            <div class="flex items-center gap-2">
                <span class="material-symbols-outlined text-indigo-600">grid_view</span>
                <h2 class="text-xl font-bold text-gray-900">${locale.t('main.all_works')}</h2>
            </div>
            <div class="flex gap-2">
                <button id="filter-all" class="px-3 py-1 text-xs font-bold rounded-full bg-indigo-600 text-white transition-colors shadow-sm">${locale.t('main.filter_all')}</button>
                <button id="filter-webtoon" class="px-3 py-1 text-xs font-bold rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 transition-colors">${locale.t('main.filter_webtoon')}</button>
                <button id="filter-webnovel" class="px-3 py-1 text-xs font-bold rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 transition-colors">${locale.t('main.filter_webnovel')}</button>
            </div>
        </div>
        <div id="home-gallery-grid" class="min-h-[200px]">
            <div class="flex justify-center py-10">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            </div>
        </div>
    `;

    // Data Loading Logic (Self-contained)
    (async () => {
        try {
            const allSeries = await ContentService.getSeriesList(40);
            const gridArea = container.querySelector('#home-gallery-grid');

            // Access Controller's injected event data?
            // Since this section fetches its own data, it might miss the "Golden Time" updates 
            // if we don't pass them or subscribe.
            // However, sticking to the Controller pattern, maybe we should've passed data.
            // But for lazy loading optimization, self-fetching is better.
            // FIXME: Ideally, this component handles its own data but syncs with EventService.
            // For now, let's just render. (Refinement later or rely on SeriesCard defaults)

            const renderGrid = (filterType) => {
                let filtered = allSeries;
                if (filterType === 'webtoon') filtered = allSeries.filter(s => s.type === 'webtoon' || s.contentType === 'webtoon' || s.type === 'davinci');
                if (filterType === 'webnovel') filtered = allSeries.filter(s => s.type === 'webnovel' || s.contentType === 'webnovel' || s.type === 'novel');

                gridArea.innerHTML = '';
                if (filtered.length === 0) {
                    gridArea.innerHTML = '<div class="text-center text-gray-400 py-10 text-sm">해당 카테고리의 작품이 없습니다.</div>';
                } else {
                    gridArea.appendChild(SearchResultsGrid(filtered, locale.t('main.all_works')));
                }
            };

            renderGrid('all');

            // Events
            const btns = {
                all: container.querySelector('#filter-all'),
                webtoon: container.querySelector('#filter-webtoon'),
                webnovel: container.querySelector('#filter-webnovel')
            };

            const setActive = (type) => {
                Object.values(btns).forEach(btn => {
                    btn.className = "px-3 py-1 text-xs font-bold rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 transition-colors";
                });
                btns[type].className = "px-3 py-1 text-xs font-bold rounded-full bg-indigo-600 text-white transition-colors shadow-sm";
                renderGrid(type);
            };

            btns.all.onclick = () => setActive('all');
            btns.webtoon.onclick = () => setActive('webtoon');
            btns.webnovel.onclick = () => setActive('webnovel');

        } catch (e) {
            console.error("Gallery Load Error:", e);
            const gridArea = container.querySelector('#home-gallery-grid');
            if (gridArea) gridArea.innerHTML = '<div class="text-red-500 text-center py-4">목록 로딩 실패</div>';
        }
    })();

    return container;
};
